import { render } from "./AppConfirmation.vue?vue&type=template&id=0b0c56a0"
import script from "./AppConfirmation.vue?vue&type=script&lang=js"
export * from "./AppConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__